import React, { useRef } from "react";
import {
  Design1,
  Design10,
  Design11,
  Design12,
  Design13,
  Design2,
  Design3,
  Design4,
  Design5,
  Design6,
  Design7,
  Design8,
  Design9,
  Img1,
  Img1Wrapper,
  Img2,
  Img3,
  Wrapper,
} from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const DesignCom = () => {
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Wrapper>
      <Img1Wrapper loading="lazy">
        <Img1 loading="lazy" src="/assets/img/WhatIsSketch_9.png" alt="" ref={ref1} className="fade-in" />
      </Img1Wrapper>
      <Img2
        loading="lazy"
        src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/3806cd09WhatIsSketch_25.png"
        alt=""
      />
      <Img3
        loading="lazy"
        src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/60d99547WhatIsSketch_26.png"
        alt=""
      />
      {/* <Design1></Design1>
      <Design2></Design2>
      <Design3></Design3> */}
      <Design4></Design4>
      <Design5></Design5>
      <Design6></Design6>
      <Design7></Design7>
      <Design8></Design8>
      <Design9></Design9>
      <Design13></Design13>
      <Design10></Design10>
      <Design11></Design11>
      <Design12></Design12>
    </Wrapper>
  );
};

export default DesignCom;
